// src/services/courses.js
import api from "./api";

// 📚 Get all courses
export const getCourses = () => {
  return api.get("/courses");
};

// 📦 Get Course Bundle Data
export const getCourseBundle = (courseId) => {
  return api.get(`/courses/${courseId}/bundle`);
};

// ➕ Create course
export const createCourse = (data) => {
  return api.post("/courses", null, {
    params: {
      title: data.title,
      description: data.description,
      price: data.price,
      original_price: data.original_price,
      category: data.category,
      thumbnail: data.thumbnail || ""
    },
  });
};

// ✏️ Update course
export const updateCourse = (courseId, data) => {
  return api.put(`/courses/${courseId}`, data);
};

// 🗑️ Delete course
export const deleteCourse = (courseId) => {
  return api.delete(`/courses/${courseId}`);
};

// 📁 Get modules for a course
export const getModules = (courseId) => {
  return api.get(`/courses/${courseId}/modules`);
};

// ➕ Create module
export const createModule = (courseId, title) => {
  return api.post(`/courses/${courseId}/modules`, { title });
};

// ✏️ Update module
export const updateModule = (moduleId, title) => {
  return api.put(`/courses/modules/${moduleId}`, { title });
};

// 🗑️ Delete module
export const deleteModule = (moduleId) => {
  return api.delete(`/courses/modules/${moduleId}`);
};

// 🎥 Create lesson
export const createLesson = (data) => {
  return api.post("/courses/lessons", {
    module_id: data.module_id,
    title: data.title,
    type: data.type,
    content_url: data.content_url,
  });
};

// ✏️ Update lesson
export const updateLesson = (lessonId, title) => {
  return api.put(`/courses/lessons/${lessonId}`, { title });
};

// 🗑️ Delete lesson
export const deleteLesson = (lessonId) => {
  return api.delete(`/courses/lessons/${lessonId}`);
};

// 🎬 Get lessons of a course
export const getLessons = (courseId) => {
  return api.get(`/courses/${courseId}/lessons`);
};

// 🗺️ Get course curriculum (modules + lessons)
export const getCurriculum = (courseId) => {
  return api.get(`/courses/${courseId}/curriculum`);
};

export const getTeacherCourses = () => {
  return api.get("/courses");
};
